import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type GanttSimulationTaskStateState = {
  frozenTaskIds: number[];
  taskToPublishIds: number[];
};

export type GanttSimulationTaskStateActions = {
  addFrozenTaskIds: (taskIds: number[]) => void;
  removeFrozenTaskIds: (taskIds: number[]) => void;
  setFrozenTaskIds: (taskIds: number[]) => void;
  setTaskToPublishIds: (taskIds: number[]) => void;
  removeTaskToPublishIds: (taskIds: number[]) => void;
  addTaskToPublishIds: (taskIds: number[]) => void;
};

export const useGanttSimulationTaskStateStore = create(
  immer<GanttSimulationTaskStateState & GanttSimulationTaskStateActions>((set) => {
    return {
      frozenTaskIds: [],
      taskToPublishIds: [],
      addFrozenTaskIds: (taskIds) =>
        set((state) => {
          state.frozenTaskIds = [...state.frozenTaskIds, ...taskIds];
        }),
      removeFrozenTaskIds: (taskIds) =>
        set((state) => {
          state.frozenTaskIds = state.frozenTaskIds.filter((id) => !taskIds.includes(id));
        }),
      setFrozenTaskIds: (taskIds) =>
        set((state) => {
          state.frozenTaskIds = taskIds;
        }),
      setTaskToPublishIds: (taskIds) =>
        set((state) => {
          state.taskToPublishIds = taskIds;
        }),
      removeTaskToPublishIds: (taskIds) =>
        set((state) => {
          state.taskToPublishIds = state.taskToPublishIds.filter((id) => !taskIds.includes(id));
        }),
      addTaskToPublishIds: (taskIds) =>
        set((state) => {
          state.taskToPublishIds = [...state.taskToPublishIds, ...taskIds];
        }),
    };
  }),
);

export const isTaskFrozenSelector = (taskId: number) => (state: GanttSimulationTaskStateState) =>
  state.frozenTaskIds.includes(taskId);

export const isTaskToPublishSelector = (taskId: number) => (state: GanttSimulationTaskStateState) =>
  state.taskToPublishIds.includes(taskId);
